import { useBranding } from '@/lib/branding-context';
import { cn } from '@/lib/utils';

interface BrandingLogoHeaderProps {
  className?: string;
}

export function BrandingLogoHeader({ className }: BrandingLogoHeaderProps) {
  const { branding } = useBranding();

  if (branding.appLogoUrl) {
    return (
      <img
        src={branding.appLogoUrl}
        alt={branding.appName}
        className={cn(
          'max-h-16 sm:max-h-20 w-auto max-w-full mx-auto object-contain',
          className
        )}
      />
    );
  }

  return (
    <h1
      className={cn(
        'text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white',
        className
      )}
    >
      {branding.appName}
    </h1>
  );
}
